import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};

  .tablePedidos:not(td) {
    background-color: #e6f7ff !important;
  }
`;

export const TitleTab = styled.div`
  * {
    font-size: 18px;
    font-weight: 500;
    color: #3c6ab4;
  }
`;
